<dx-data-grid class="pointer hideSave " [dataSource]="dataSourceEmployees"
                    [class]="classDataGrid"
                    [allowColumnResizing]="true"
                    columnResizingMode="nextColumn"
                    showBorders="false"
                    [rowAlternationEnabled]="true"
                    [columnAutoWidth]="true"
                    (onEditorPreparing)="onEditorPreparing($event)"
                    (onCellHoverChanged)="onCellHoverChanged($event)"
                    (onInitNewRow)="onInitNewRow($event)"
                    (onExporting)="customizeExportData($event.columns, $event.rows)"
                    (onCellPrepared)="onCellPrepared($event)"
                    (onCellClick)="onCellClick($event)">
      <dxo-group-panel [visible]="groupPanelVisible"></dxo-group-panel>
      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
      <dxo-export [enabled]="true" [fileName]="titleEmployee"></dxo-export>
      <dxo-editing mode="row" [useIcons]="true"
                      [allowUpdating]="true"
                      [allowDeleting]="allowDeleting"
                      [allowAdding]="allowAdding"></dxo-editing>
      <dxo-header-filter [visible]="headerFilterVisible"></dxo-header-filter>
      <dxo-sorting mode="single"></dxo-sorting>



      <dxi-column cellTemplate="btnCellTemplate" [width]="50" [visible]="showBtnCell" [allowEditing]="false" ></dxi-column>
      <dxi-column dataField="Photo" [allowSearch]="false" [width]="70" cellTemplate="photoCellTemplate" editCellTemplate="photoEditCellTemplate" [setCellValue]="setPhotoValue"  ></dxi-column>
      <dxi-column dataField="EmployeeNumber" [caption]="this.languageService.LNG('Label.Empl.No')"  [width]="60"  >
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="FirstName" [caption]="this.languageService.LNG('Label.FirstName')"    >
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="SurName" [caption]="this.languageService.LNG('Label.SurName')"    >
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
      <dxi-column dataField="DepartmentId" [caption]="this.languageService.LNG('Label.Department')" [visible]="showDepartmentColumn" cellTemplate="departmentCellTemplate" >
        <dxo-lookup [dataSource]="departments"
                    displayExpr="Name"
                    valueExpr="DepartmentId">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="Hired" caption="{{languageService.LNG('Label.Hired.Date')}}" dataType="date" format="dd.MM.yyyy" editCellTemplate="hiredDateEditTemplate" [setCellValue]="setHiredDateValue"  [width]="130" [visible]="showHiredColumn"></dxi-column>
      <dxi-column dataField="Quit" caption="{{languageService.LNG('Label.Quit')}}" dataType="date" format="dd.MM.yyyy" editCellTemplate="quitDateEditTemplate" [setCellValue]="setQuitDateValue"  [width]="130"></dxi-column>
      <dxi-column dataField="Gender" [caption]="this.languageService.LNG('Label.Gender')" [width]="70" cellTemplate="genderCellTemplate" editCellTemplate="genderEditCellTemplate" [setCellValue]="setGenderValue"></dxi-column>
      <dxi-column dataField="UserId" [caption]="this.languageService.LNG('Label.Username')"   >
          <dxi-validation-rule type="required"></dxi-validation-rule>
      </dxi-column>
      <!-- <dxi-column dataField="Password" [caption]="this.languageService.LNG('Label.Password')"   ></dxi-column> -->
      <dxi-column dataField="Email" [caption]="this.languageService.LNG('Label.Email')" [visible]="showEmailColumn"  ></dxi-column>
      <dxi-column dataField="Phone" [caption]="this.languageService.LNG('Label.Phone')" [width]="90" ></dxi-column>
      <dxi-column dataField="LanguageCode" [caption]="this.languageService.LNG('Label.Language')" [width]="75" editCellTemplate="languageEditCellTemplate" [setCellValue]="setLanguageValue"
      [visible]="showLanguageColumn">
          <!-- <dxi-validation-rule  type="required"></dxi-validation-rule> -->
      </dxi-column>


      <dxi-column dataField="SupervisorId" [caption]="this.languageService.LNG('Label.Supervisor')" [visible]="showSupervisorColumn" >
        <dxo-lookup [dataSource]="supervisors"
                      displayExpr="FullName"
                      valueExpr="EmployeeId">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="SuspendBlockingDate" caption="{{languageService.LNG('Label.SuspendBlockingDate')}}" dataType="date" format="dd.MM.yyyy" editCellTemplate="suspendBlockingDateEditTemplate" [setCellValue]="setSuspendBlockingDateValue"  [width]="130" [visible]="showSuspendBlockingDateColumn"></dxi-column>


      <dxi-column dataField="CalculationMethod" [caption]="this.languageService.LNG('Label.Calculation')"  >
        <dxo-lookup [dataSource]="calculationMethods"
                      displayExpr="Description"
                      valueExpr="CalculationMethodId">
        </dxo-lookup>
      </dxi-column>

      <dxi-column dataField="WeekPlanId" [caption]="this.languageService.LNG('Label.Weekplan')"  [visible]="showWeekPlanColumn" >
        <dxo-lookup [dataSource]="weekplans"
                      displayExpr="Code"
                      valueExpr="WeekPlanId">
        </dxo-lookup>
      </dxi-column>
      <!-- <dxi-column dataField="ReportAccess" [caption]="this.languageService.LNG('Label.Report')" [width]="100" ></dxi-column> -->
      <!-- <dxi-column dataField="TransferSalary" [caption]="this.languageService.LNG('Label.Salary')" [width]="80" ></dxi-column> -->
      <dxi-column dataField="TransferSalaryGroupName" [caption]="this.languageService.LNG('Label.Salary')"  editCellTemplate="salaryGroupEditTemplate" [setCellValue]="setSalaryGroupValue"
                [visible]="showTransferSalaryColumn" >
        <!-- <dxo-lookup [dataSource]="salaryGroups"
          displayExpr="Name"
          valueExpr="GroupId">
        </dxo-lookup> -->
      </dxi-column>
      <!-- <dxi-column dataField="UseBalance" [caption]="this.languageService.LNG('Label.Balance')" [width]="80" ></dxi-column> -->
      <dxi-column dataField="BalanceGroupName" [caption]="this.languageService.LNG('Label.Balance')"  editCellTemplate="balanceGroupEditTemplate" [setCellValue]="setBalanceGroupValue"
                  [visible]="showBalanceGroupColumn"  >
        <!-- <dxo-lookup [dataSource]="balanceGroups"
          displayExpr="Name"
          valueExpr="GroupId">
        </dxo-lookup> -->
      </dxi-column>

      <div *dxTemplate="let c of 'btnCellTemplate'">
        <dx-button icon="bookmark" (onClick)="onEmployeeTagClick(c.data)"></dx-button>
      </div>

      <div *dxTemplate="let cell of 'photoCellTemplate'">
        <!-- <img *ngIf="cell.data.Photo === null" alt="" src="./assets/images/avatar.png" title="klikk"  style="display:table-cell; height: 50px; width: 50px; border-radius: 75px !important"> -->
        <img  #imglogo style="display:table-cell; height: 50px; width: 50px; border-radius: 75px !important" [src]="cell.data.Photo" />

      </div>

      <div *dxTemplate="let cell of 'photoEditCellTemplate'">
        <input #uploadPhoto   type="file" accept="image/*" hidden (change)="onValueChangedPhoto($event, cell)" />
        <img  #imglogo style="display:table-cell; height: 50px; width: 50px; border-radius: 75px !important" [src]="cell.data.Photo" (click)="uploadPhoto.click()" />
      </div>
      <div *dxTemplate="let cell of 'genderCellTemplate'">
          <fa-icon *ngIf="cell.data.Gender == 'M'" [icon]="faMale" size="2x"></fa-icon>
          <fa-icon *ngIf="cell.data.Gender == 'F'" [icon]="faFemale" size="2x"></fa-icon>
      </div>
      <div *dxTemplate="let cell of 'genderEditCellTemplate'">
          <dx-select-box
              [dataSource]="genders"
              displayExpr="Gender"
              valueExpr="Gender"
              (onValueChanged)="onGenderValueChanged($event, cell)"
              [value]="cell.data.Gender"
              fieldTemplate="field">
              <div *dxTemplate="let data of 'field'">
                  <fa-icon *ngIf="data && data.Gender == 'M'" [icon]="faMale"  size="2x" style="padding-left: 8px; padding-top: 3px; padding-bottom: 3px"></fa-icon>
                  <fa-icon *ngIf="data && data.Gender == 'F'" [icon]="faFemale" size="2x" style="padding-left: 8px; padding-top: 3px; padding-bottom: 3px"></fa-icon>
                  <dx-text-box class="product-name"
                            [value]="data && data.Gender"
                            [readOnly]="true" [visible]="data !== null ? false: true"
                        ></dx-text-box>
              </div>
              <div *dxTemplate="let data of 'item'">
                  <fa-icon *ngIf="data.Gender == 'M'" [icon]="faMale" size="2x"></fa-icon>
                  <fa-icon *ngIf="data.Gender == 'F'" [icon]="faFemale" size="2x"></fa-icon>
              </div>
          </dx-select-box>
      </div>

      <div *dxTemplate="let data of 'departmentCellTemplate'">
        {{data.data.DepartmentName}}
      </div>
      <div *dxTemplate="let data of 'hiredDateEditTemplate'">
        <dx-date-box
          [value]="data.data.Hired" [showClearButton]="false"  displayFormat="dd.MM.yyyy" (onValueChanged)="onHiredDateChanged($event, data)">
        </dx-date-box>
      </div>
      <div *dxTemplate="let data of 'quitDateEditTemplate'">
        <dx-date-box
          [value]="data.data.Quit" [showClearButton]="false"  displayFormat="dd.MM.yyyy" (onValueChanged)="onQuitDateChanged($event, data)">
        </dx-date-box>
      </div>
      <div *dxTemplate="let data of 'suspendBlockingDateEditTemplate'">
        <dx-date-box
          [value]="data.data.SuspendBlockingDate" [showClearButton]="false"  displayFormat="dd.MM.yyyy" (onValueChanged)="onSuspendBlockingDateChanged($event, data)">
        </dx-date-box>
      </div>
      <div *dxTemplate="let data of 'salaryGroupEditTemplate'">
            <dx-select-box [dataSource]="salaryGroups"
                        displayExpr="Name"
                        searchExpr="Name"
                        valueExpr="GroupId"
                        (onValueChanged)="onSalaryGroupChanged($event, data)"
                        [value]="data.data.TransferSalaryGroupId">
            </dx-select-box>
      </div>
      <div *dxTemplate="let data of 'balanceGroupEditTemplate'">
            <dx-select-box [dataSource]="balanceGroups"
                        displayExpr="Name"
                        searchExpr="Name"
                        valueExpr="GroupId"
                        (onValueChanged)="onBalanceGroupChanged($event, data)"
                        [value]="data.data.BalanceGroupId">
            </dx-select-box>
      </div>
      <div *dxTemplate="let data of 'languageEditCellTemplate'">
            <dx-select-box [dataSource]="languages"
                        displayExpr="Code"
                        searchExpr="Code"
                        valueExpr="LanguageId"
                        (onValueChanged)="onLanguageChanged($event, data)"
                        [value]="data.data.LanguageId">
            </dx-select-box>
      </div>
    </dx-data-grid>

<dx-tooltip>
    <div *dxTemplate="let data = data of 'content'">
        <span>{{toolTipColumn}}</span>
    </div>
</dx-tooltip>
